import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQuery, getBaseUrl } from "../config";

const myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");

const requestOptions = {
  method: "GET",
  headers: myHeaders,
};

export const loadChannels = async () => {
  return await fetch(`${getBaseUrl()}/api/v1/channels`, requestOptions);
};

export const channelApi = createApi({
  reducerPath: "channelApi",
  baseQuery: createBaseQuery(""),
  tagTypes: ["channelApi"],
  endpoints: (build) => ({
    loadChannels: build.query<Channel[], void>({
      query: () => ({
        url: "channels",
        method: "GET",
      }),
    }),
  }),
});
